import React from 'react';
import { AuthProvider } from './contexts/auth-context';
import { TenantProvider } from './contexts/tenant-context';
import { SubdomainRouter } from './components/SubdomainRouter';

function App() {
  return (
    <AuthProvider>
      <TenantProvider>
        <SubdomainRouter />
      </TenantProvider>
    </AuthProvider>
  );
}

export default App;
